export default {"src":"/_next/static/media/CFG.d4168d06.svg","height":18,"width":18};